export * from './page/page.component';
